/**
 * Nutzungsbedingungen & Co.: versionierte PDFs im öffentlichen Bucket
 * `rechtstexte`, Zustimmung je Betrieb per RPC (speichert Version, SHA-256,
 * Zeitpunkt, IP und meldet sie ans CRM in admin.optero.app).
 */

import { supabase } from './supabaseClient';

export const RECHTSTEXT_TITEL = {
    nutzungsbedingungen: 'Nutzungsbedingungen',
    datenschutz: 'Datenschutzhinweise',
    avv: 'Auftragsverarbeitungsvertrag',
};

/** Aktive Versionen, denen der Inhaber des aktiven Betriebs noch nicht zugestimmt hat. */
export async function offeneRechtstexte() {
    const { data, error } = await supabase.rpc('offene_rechtstexte');
    if (error) throw new Error(error.message);
    return data || [];
}

export async function rechtstextZustimmen(id) {
    const { error } = await supabase.rpc('rechtstext_zustimmen', { p_id: id });
    if (error) throw new Error(error.message);
}

export function rechtstextUrl(text, download = false) {
    const name = `Optero-${RECHTSTEXT_TITEL[text.art] || text.art}-${text.version}.pdf`;
    return supabase.storage.from('rechtstexte')
        .getPublicUrl(text.datei_pfad, download ? { download: name } : undefined).data.publicUrl;
}
